import { useMemo } from "react";
import { useAppSelector } from "../redux/hooks";
import { getPermissionAccessContext } from "../utils/permissionAccess";

export function usePermissionAccess() {
  const userProfile = useAppSelector((state) => state.userProfile);
  return useMemo(() => getPermissionAccessContext(userProfile), [userProfile]);
}
